import { gradeTypes } from '$variables/constants';

const areGradeTypesPercentage = (assignments) =>
  assignments
    .map(({ gradeType }) => gradeType === gradeTypes.percentage)
    .every((isPercentage) => isPercentage);

export default areGradeTypesPercentage;
